import type {
  GetQuestionsQueryParamsDTO, IndexQuestionCollectionResourceDTO,
  CreateQuestionRequestDTO, StoreQuestionResourceDTO, QuestionDTO,
  AnswerVoteResourceDTO, AnswerDTO, GetAnswersQueryParamsDTO,
  PostAnswerRequestDTO, IndexAnswerCollectionResourceDTO,
  StoreAnswerResourceDTO, GetAnswerQueryParamsDTO, GetAnswerResourceDTO,
  UpdateAnswerRequestDTO,
  GetQuestionQueryParamsDTO,
} from './ms-qna.dto';

const qnaPaths = {
  allQuestions: '/questions-answers/questions' as const,
  singleQuestion: (id: string) => `/questions-answers/questions/${id}` as const,
  allAnswer: '/questions-answers/answers' as const,
  voteOnAnswer: (id: string) => `/questions-answers/answers/${id}/votes` as const,
  singleAnswer: (id: string) => `/questions-answers/answers/${id}` as const,
};

// Function to fetch questions
export const getQuestions = (params: GetQuestionsQueryParamsDTO) => {
  const options = {
    method: 'GET',
    params,
    withoutAuthorization: true,
    useMS: true,
  };

  return $cpFetch<IndexQuestionCollectionResourceDTO>(qnaPaths.allQuestions, options);
};

export const postQuestion = (body: CreateQuestionRequestDTO) => {
  const options = {
    method: 'POST',
    body,
    withoutAuthorization: true,
    useMS: true,
  };

  return $cpFetch<StoreQuestionResourceDTO>(qnaPaths.allQuestions, options);
};

export const getQuestion = (id: string, params: GetQuestionQueryParamsDTO) => {
  const options = {
    method: 'GET',
    params,
    withoutAuthorization: true,
    useMS: true,
  };

  return $cpFetch<{data: QuestionDTO}>(qnaPaths.singleQuestion(id), options);
};

export const updateQuestion = (id: string, body: CreateQuestionRequestDTO) => {
  const options = {
    method: 'PATCH',
    body,
    withoutAuthorization: true,
    useMS: true,
  };

  return $cpFetch<QuestionDTO>(qnaPaths.singleQuestion(id), options);
};

export const voteOnAnswer = (id: string, body: AnswerVoteResourceDTO) => {
  const options = {
    method: 'POST',
    body,
    withoutAuthorization: true,
    useMS: true,
  };

  return $cpFetch<AnswerDTO>(qnaPaths.voteOnAnswer(id), options);
};


export const getAnswers = (params: GetAnswersQueryParamsDTO) => {
  const options = {
    method: 'GET',
    params,
    withoutAuthorization: true,
    useMS: true,
  };

  return $cpFetch<IndexAnswerCollectionResourceDTO>(qnaPaths.allAnswer, options);
};

export const postAnswer = (body: PostAnswerRequestDTO) => {
  const options = {
    method: 'POST',
    body,
    withoutAuthorization: true,
    useMS: true,
  };

  return $cpFetch<StoreAnswerResourceDTO>(qnaPaths.allAnswer, options);
};

export const getAnswerById = (id: string, params?: GetAnswerQueryParamsDTO) => {
  const options = {
    method: 'GET',
    params,
    withoutAuthorization: true,
    useMS: true,
  };

  return $cpFetch<GetAnswerResourceDTO>(qnaPaths.singleAnswer(id), options);
};

export const updateAnswer = (id: string, body: UpdateAnswerRequestDTO) => {
  const options = {
    method: 'PATCH',
    body,
    withoutAuthorization: true,
    useMS: true,
  };

  return $cpFetch<GetAnswerResourceDTO>(qnaPaths.singleAnswer(id), options);
};
